import React from "react";
import SSLTableElement from "../SSLTableElement/SSLTableElement";
import TrueFalseTableElement from "../Common/TrueFalseTableElement/TrueFalseTableElement.jsx";
import { extractFloorlytics } from "../../utils";

function HistoryTable(props) {
  const rows = props.sites.map((site, index) => (
    <HistoryTableRow key={index} site={site} />
  ));

  return (
    <div>
      <h2>Checkup History</h2>
      <table>
        <thead>
          <tr>
            <th>HOME STATUS</th>
            <th>SSL STATUS</th>
            <th>SITE SPEED</th>
            <th>MOBILE SITE SPEED</th>
            <th>FLOORLYTICS</th>
            <th>BROKEN LINKS</th>
            <th>RUN TIME</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
}

function HistoryTableRow({ site }) {
  const runDate = new Date(site.date).toLocaleDateString();

  return (
    <tr>
      <td>{site.status}</td>
      <SSLTableElement expiration={site.ssl_expiration} />
      <td>{site.site_speed}</td>
      <td>{site.mobile_site_speed}</td>
      <td>
        <TrueFalseTableElement {...extractFloorlytics(site)} />
      </td>
      <td>{site.broken_links}</td>
      <td>{runDate}</td>
    </tr>
  );
}

export default HistoryTable;
